import React from 'react'
import {
  Link,
  Route,
} from 'react-router-dom'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'
import Button from '../../../../Button'

export default ({ to, children, ...rest }) => (
  <Route path={to}>
    {({ match }) => (
      <WindowWidthSensor>
        {({ width }) => {
          const small = width < 768
          const mobile = width < 500

          return (
            <Button
              type={match ? 'active' : 'inactive'}
              as={Link}
              to={to}
              padding={small ? '10px' : '10px 20px'}
              borderRadius={mobile && '8px'}
            >
              {children}
            </Button>
          )
        }}
      </WindowWidthSensor>
    )}
  </Route>
)
